import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Dialog, DialogContent, DialogTitle, Typography,
} from '@material-ui/core';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import BeneficaryLayout from 'Components/UI/Accounts/AccountApplication/Step/BeneficiaryInformation/BeneficiaryLayout';
import {
  AccountApplicationStepOverride,
  AccountApplicationStepOverrideOrganization,
  AccountApplicationStepOverrideOrganizationRelationshipOther, AccountApplicationStepOverrideRelationshipOther,
} from 'Overrides/AccountDetails';
import useMobileLayout from 'Hooks/useMobileLayout';

function BeneficayModal({
  classes, onCancel, onSubmit, onDelete, beneficary, setBeneficiary,
}) {
  const isMobile = useMobileLayout();
  const [override, setOverride] = useState(AccountApplicationStepOverride);

  function onUpdate(isOrganization, relationshipType) {
    let newOverride = AccountApplicationStepOverride;
    if (relationshipType === 'OTHER') {
      newOverride = AccountApplicationStepOverrideRelationshipOther;
    }
    if (isOrganization === 'true') {
      if (relationshipType === 'OTHER') {
        newOverride = AccountApplicationStepOverrideOrganizationRelationshipOther;
      } else {
        newOverride = AccountApplicationStepOverrideOrganization;
      }
    }
    const newBeneficiary = beneficary.overrideMeta(newOverride);
    newBeneficiary.parentInstance = beneficary.parentInstance;
    setBeneficiary(newBeneficiary);
    setOverride(newOverride);
  }

  function onOrganizationUpdate(isOrganization) {
    onUpdate(isOrganization, beneficary.attr('relationshipType'));
  }

  function onRelationshipTypeUpdate(relationshipType) {
    onUpdate(beneficary.attr('isOrganization'), relationshipType);
  }

  useEffect(() => {
    onOrganizationUpdate(beneficary.attr('isOrganization'));
    onRelationshipTypeUpdate(beneficary.attr('relationshipType'));
  }, [beneficary.id()]);

  return (
    <Dialog classes={{ root: classes.root, paper: classes.paper }} fullScreen={isMobile} open>
      <DialogTitle>
        <Typography className={classes.header} color="primary" align="center" variant="h2" component="h1">
          {'Beneficiary Personal Information'}
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <div className={classes.container}>
          <MetaFormInline
            confirmDeleteMessage={!beneficary.id() ? null : `${beneficary.attr('firstName')} ${beneficary.attr('lastName')} will be removed from the account and all information will be deleted.`}
            resource={beneficary}
            layout={BeneficaryLayout}
            onDelete={!beneficary.id() ? null : onDelete}
            onCancel={onCancel}
            onSubmit={onSubmit}
            allowSubmitDisable={false}
            metaOverrideSet={override}
            LayoutProps={{
              onOrganizationUpdate,
              onRelationshipTypeUpdate,
            }}
            classes={{
              actions: classes.actions,
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

BeneficayModal.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  beneficary: PropTypes.object.isRequired,
  setBeneficiary: PropTypes.func.isRequired,
};

export default withStyles(theme => ({
  root: {},
  paper: {
    maxWidth: theme.dimensions.xl,
    maxHeight: '100%',
    overflow: 'auto',
    paddingBottom: theme.spacing(5),
  },
  content: {
    maxHeight: '100%',
    overflow: 'auto',
  },
  header: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  actions: {
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: 0,
    minWidth: theme.dimensions.sm,
    width: 'calc(100% - 64px)',
  },
  [theme.breakpoints.down('md')]: {
    paper: {
      maxWidth: 'unset',
    },
  },
}))(BeneficayModal);
